import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.717 1.822 C 4.036 2.011,2.563 3.122,1.928 4.680 C 1.288 6.249,1.532 8.004,2.576 9.345 C 2.720 9.530,3.097 9.912,3.302 10.080 C 4.189 10.807,5.453 11.205,6.569 11.109 C 7.509 11.028,8.328 10.721,9.042 10.183 L 9.246 10.029 10.392 11.172 C 11.458 12.236,11.545 12.317,11.635 12.331 C 11.817 12.360,11.996 12.266,12.084 12.094 C 12.117 12.030,12.118 11.854,12.085 11.767 C 12.072 11.731,11.556 11.197,10.940 10.579 L 9.819 9.457 9.972 9.250 C 10.470 8.577,10.770 7.827,10.872 7.001 C 10.908 6.713,10.902 6.132,10.861 5.828 C 10.569 3.701,8.851 2.037,6.723 1.821 C 6.446 1.793,5.973 1.794,5.717 1.822 M6.795 2.649 C 8.062 2.839,9.113 3.604,9.695 4.759 C 10.087 5.538,10.189 6.543,9.965 7.414 C 9.688 8.492,8.946 9.409,7.944 9.912 C 7.720 10.024,7.267 10.180,7.023 10.229 C 5.724 10.491,4.392 10.082,3.487 9.143 C 2.758 8.388,2.399 7.498,2.399 6.452 C 2.400 5.829,2.492 5.403,2.749 4.842 C 3.218 3.817,4.154 3.024,5.232 2.740 C 5.705 2.615,6.327 2.579,6.795 2.649 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgMagnifyingGlass;
